import { useStrictLocalization } from "@faire/web/common/localization";
export var useFormatTime = function useFormatTime(milliseconds) {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  if (milliseconds < 0) {
    return "";
  }
  var minutes = Math.floor(milliseconds / 60000);
  var hours = Math.floor(milliseconds / 3600000);
  if (hours > 1) {
    return strictLocalize({
      id: "oGeXX+",
      defaultMessage: [{
        "type": 1,
        "value": "hoursTime"
      }, {
        "type": 0,
        "value": " uur"
      }]
    }, {
      hoursTime: String(hours)
    });
  } else if (hours === 1) {
    return strictLocalize({
      id: "QdMa8l",
      defaultMessage: [{
        "type": 0,
        "value": "1 uur"
      }]
    });
  } else if (minutes > 1) {
    return strictLocalize({
      id: "hjNMLy",
      defaultMessage: [{
        "type": 1,
        "value": "minutesTime"
      }, {
        "type": 0,
        "value": " minuten"
      }]
    }, {
      minutesTime: String(minutes)
    });
  } else if (minutes === 1) {
    return strictLocalize({
      id: "i7CIDB",
      defaultMessage: [{
        "type": 0,
        "value": "1 minuut"
      }]
    });
  } else {
    return strictLocalize({
      id: "FHoOQG",
      defaultMessage: [{
        "type": 0,
        "value": "3 minuten"
      }]
    });
  }
};